import type {SoporteCasilla} from '@/hooks/sgsst/evaluacion/use-sgsst'

/** Una opción por casilla y por variante (`key|kind`), para que un solo select responda
 * «¿Qué documento es?» sin partir 1.1.4 en cuatro casillas. */
export function pickerOptions(casillas: SoporteCasilla[]): {value: string; label: string}[] {
  return casillas.flatMap((casilla) => [
    {value: casilla.key, label: casilla.titulo},
    ...casilla.variantes.map((v) => ({value: `${casilla.key}|${v.kind}`, label: `${casilla.titulo} · ${v.titulo}`})),
  ])
}

export function pickerValue(soporteKey: string | null, kind: string): string {
  if (!soporteKey) return ''
  return kind === 'file' ? soporteKey : `${soporteKey}|${kind}`
}

export function parsePickerValue(value: string): {soporteKey: string | null; kind: string} {
  if (!value) return {soporteKey: null, kind: 'file'}
  const [soporteKey, kind] = value.split('|')
  return {soporteKey, kind: kind ?? 'file'}
}
